import SuperFetch from 'library/helpers/superFetch';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { Notification } from 'zComponents/atoms';
import { roleActions } from './slice';
import { organisationActions } from 'reduxStore/organisations/slice';

// Existing getRoles saga
export function* getRoles() {
	try {
		const { orgID } = yield select((state) => state.Auth.selectedProfile);

		const roles = yield call(() => SuperFetch.get('/roles'));

		if (roles.statusCode === 200) {
			yield put(roleActions.loadRolesSuccess({ orgID, data: roles.data }));
		} else {
			throw Error(roles.error.message || roles.error || 'Failed to load roles.');
		}
	} catch (error) {
		yield put(roleActions.loadRolesError(error));
	}
}

// 🚀 Assign Role Saga
function* assignRole({ payload }) {
	try {
		const response = yield call(() => SuperFetch.post('/roles/grantRole', payload));

		if (response.statusCode === 200) {
			yield put(roleActions.assignRoleSuccess());
			Notification('success', 'Role has been assigned successfully.');
		} else {
			throw Error(response.error?.message || response.error || 'Failed to assign role.');
		}
	} catch (error) {
		yield put(roleActions.assignRoleError(error.message));
		Notification('error', error.message || 'Failed to assign role.');
	}
}

// 🚀 Assign Role Success Saga
function* assignRoleSuccess() {
	yield put(roleActions.loadRoles());
	yield put(organisationActions.loadOrganisations());
}

// 🚀 Revoke Role Saga
function* revokeRole({ payload }) {
	try {
		const response = yield call(() => SuperFetch.post('/roles/revokeRole', payload));

		if (response.statusCode === 200) {
			yield put(roleActions.revokeRoleSuccess());
			Notification('success', 'Role has been revoked successfully.');
		} else {
			throw Error(response.error?.message || response.error || 'Failed to revoke role.');
		}
	} catch (error) {
		yield put(roleActions.revokeRoleError(error.message));
		Notification('error', error.message || 'Failed to revoke role.');
	}
}

// 🚀 Revoke Role Success Saga
function* revokeRoleSuccess() {
	yield put(roleActions.loadRoles());
	yield put(organisationActions.loadOrganisations());
}

// 🚀 Root Saga
export default function* rolesSagas() {
	yield takeLatest(roleActions.loadRoles, getRoles);
	yield takeLatest(roleActions.assignRole, assignRole);
	yield takeLatest(roleActions.assignRoleSuccess, assignRoleSuccess); // Reload roles after assignment
	yield takeLatest(roleActions.revokeRole, revokeRole);
	yield takeLatest(roleActions.revokeRoleSuccess, revokeRoleSuccess); // Reload roles after revocation
}
